const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

export const API_ENDPOINTS = {
  VACANCIES: `${API_BASE_URL}/vacancies`,
  COMPANIES: `${API_BASE_URL}/companies`,
  CANDIDATES: `${API_BASE_URL}/candidates`,
  JOB_APPLICATIONS: `${API_BASE_URL}/job-applications`,
  JOB_CATEGORIES: `${API_BASE_URL}/vacancies/categories`,
  LOGIN: `${API_BASE_URL}/auth/login`,
  FORGOT_PASSWORD: `${API_BASE_URL}/auth/forgot-password`,
  RESET_PASSWORD: `${API_BASE_URL}/auth/reset-password`,
  VALIDATE_RESET_TOKEN: `${API_BASE_URL}/auth/reset-password/validate`,
  BLOGS:`${API_BASE_URL}/blogs`,
  BLOGS_CATEGORIES : `${API_BASE_URL}/blog-categories`,
  BLOGS_TAGS : `${API_BASE_URL}/blog-tags`,
  EMPLOYERS : `${API_BASE_URL}/employers`,
  CV_DOWNLOAD: `${API_BASE_URL}/cv/download`,
  API_BASE_URL: API_BASE_URL,
};

export default API_ENDPOINTS;